<template>
  <div class="events">
    <van-form ref="event" input-align="right" error-message-align="right">
      <van-field label="球队" :rules="[{ required: true, message: '请选择球队' }]">
        <template #input>
          <van-radio-group v-model="event.teamId" direction="horizontal" @change="clearPlayer">
            <van-radio :name="home.teamInfo?.id">{{ home.teamInfo?.name }}</van-radio>
            <van-radio :name="away.teamInfo?.id">{{ away.teamInfo?.name }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field label="时间" v-model="event.time" :rules="[{ required: true, message: '请输入时间' }]" placeholder="请输入时间（分）,例如：9"></van-field>
      <van-field label="事件类型" v-model="eventTypeText" :rules="[{ required: true, message: '请选择事件' }]" placeholder="请选择事件" readonly clickable @click="showEventPicker = true"></van-field>
      <div v-if="event.event === 1">
        <van-field label="类型" :rules="[{ required: true, message: '请选择类型' }]">
          <template #input>
            <van-radio-group v-model="event.type" direction="horizontal">
              <van-radio name="goal">普通</van-radio>
              <van-radio name="penalty">点球</van-radio>
              <van-radio name="ownGoal">乌龙</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div v-if="event.type === 'goal'">
          <van-field label="进球球员" :rules="[{ required: true, message: '请选择进球球员' }]" v-model="playerValue1" readonly clickable right-icon="arrow" @click="showTeamListFun('p1')"></van-field>
          <van-field label="助攻球员" v-model="playerValue2" readonly clickable right-icon="arrow" @click="showTeamListFun('p2')"></van-field>
        </div>
        <div v-else-if="event.type === 'ownGoal' || event.type === 'penalty'">
          <van-field label="球员" :rules="[{ required: true, message: '请选择球员' }]" v-model="playerValue3" readonly clickable right-icon="arrow" @click="showTeamListFun"></van-field>
        </div>
      </div>
      <div v-else-if="event.event === 2">
        <van-field label="类型" :rules="[{ required: true, message: '请选择类型' }]">
          <template #input>
            <van-radio-group v-model="event.type" direction="horizontal">
              <van-radio name="yellow">黄牌</van-radio>
              <van-radio name="red">红牌</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label="球员" :rules="[{ required: true, message: '请选择球员' }]" v-model="playerValue4" readonly clickable right-icon="arrow" @click="showTeamListFun"></van-field>
      </div>
      <div v-else-if="event.event === 3">
        <van-field label="上场球员" :rules="[{ required: true, message: '请选择上场球员' }]" v-model="playerValue5" readonly clickable right-icon="arrow" key="field01" @click="showTeamListFun('p1')"></van-field>
        <van-field label="下场球员" :rules="[{ required: true, message: '请选择下场球员' }]" v-model="playerValue6" readonly clickable right-icon="arrow" key="field02" @click="showTeamListFun('p2')"></van-field>
      </div>
      <div v-else-if="event.event === 4">
        <van-field label="球员" :rules="[{ required: true, message: '请选择球员' }]" v-model="playerValue3" readonly clickable right-icon="arrow" @click="showTeamListFun('p1')"></van-field>
      </div>
    </van-form>
    <div class="but" @click="goPages">
      查看事件时间轴
    </div>
    <div class="bottom">
      <van-button type="info" block round @click="update" style="background-color: #191919;">
        <span style="font-size: 16px; color: #FFFFFF">保存事件</span>
      </van-button>
    </div>
    <van-popup v-model="showTeamList" round position="bottom" :style="{ height: '50%' }" >
      <van-picker
        show-toolbar
        :columns="teamColumns"
        @confirm="onConfirm"
        @cancel="showTeamList = false"
      >
        <template #option="option">
          <div style="display: flex; flex-direction: column; align-items: center;">
            <div><span v-if="option.number">({{ option.number }})</span>{{ option.name }}</div>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showEventPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="eventTypeOptions"
        @confirm="onEventTypeConfirm"
        @cancel="showEventPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Field, Form, RadioGroup, Radio, Popup, Picker, Toast } from 'vant'
import { adminGetBMBktGameData, adminGetBMBktGameEventPlayerList, adminAddBMGameEvent, adminUpdateBMGameEvent } from "@/api/match";
import { debounce } from "@/utils/debounce";
Vue.use(Field).use(Form).use(RadioGroup).use(Radio).use(Popup).use(Picker).use(Toast)
export default {
  props: {
    isMe: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      event: {
        teamId: '',
        time: '',
        event: '',
        type: '',
        playerId: '',
        otherPlayerId: ''
      },
      game: {},
      home: {},
      away: {},
      homeTeamList: [],
      awayTeamList: [],
      showTeamList: false,
      type: '',
      playerValue1: '',
      playerValue2: '',
      playerValue3: '',
      playerValue4: '',
      playerValue5: '',
      playerValue6: '',
      eventId: '',
      showEventPicker: false,
      eventTypeOptions: [
        { text: '进球', value: 1 },
        { text: '红黄牌', value: 2 },
        { text: '换人', value: 3 },
        { text: '罚离替补席', value: 4 }
      ],
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.eventId = this.$route.query.eventId
    this.matchId = this.$route.query.matchId
    this.adminGetBMBktGameData()
    
    // 创建防抖版本的update方法
    this.debouncedUpdate = debounce(this.updateEvent, 500)
  },
  computed: {
    teamColumns() {
      const a = []
      if (this.event.event === 1) {        
        if (this.event.type === 'goal') {
          if (this.event.teamId && this.home.teamInfo?.id === this.event.teamId) {
            const playerList = JSON.parse(JSON.stringify(this.home.playerList))            
            playerList.forEach(p => {
              if (this.type === 'p1' && p.id !== this.event.otherPlayerId) {
                a.push({
                  id: p.id,
                  name: p.trueName,
                  number: p.number,
                })
              } else if (this.type === 'p2' && p.id !== this.event.playerId) {
                a.push({
                  id: p.id,
                  name: p.trueName,
                  number: p.number,
                })
              }
            })
          } else if (this.event.teamId && this.away.teamInfo?.id === this.event.teamId) {
            const playerList = JSON.parse(JSON.stringify(this.away.playerList))
            playerList.forEach(p => {
              if (this.type === 'p1' && p.id !== this.event.otherPlayerId) {
                a.push({
                  id: p.id,
                  name: p.trueName,
                  number: p.number,
                })
              } else if (this.type === 'p2' && p.id !== this.event.playerId) {
                a.push({
                  id: p.id,
                  name: p.trueName,
                  number: p.number,
                })
              }
            })
          }
        } else if (this.event.type === 'ownGoal'  || this.event.type === 'penalty') {
          if (this.event.teamId && this.home.teamInfo?.id === this.event.teamId) {
            const playerList = JSON.parse(JSON.stringify(this.home.playerList))
            playerList.forEach(p => {
              a.push({
                id: p.id,
                name: p.trueName,
                number: p.number,
              })
            })
          } else if (this.event.teamId && this.away.teamInfo?.id === this.event.teamId) {
            const playerList = JSON.parse(JSON.stringify(this.away.playerList))
            playerList.forEach(p => {
              a.push({
                id: p.id,
                name: p.trueName,
                number: p.number,
              })
            })
          }
        }
      } else if (this.event.event === 2 || this.event.event === 4) {
        if (this.event.teamId && this.home.teamInfo?.id === this.event.teamId) {
          const playerList = JSON.parse(JSON.stringify(this.home.playerList))
          playerList.forEach(p => {
            a.push({
              id: p.id,
              name: p.trueName,
              number: p.number,
            })
          })
        } else if (this.event.teamId && this.away.teamInfo?.id === this.event.teamId) {
          const playerList = JSON.parse(JSON.stringify(this.away.playerList))
          playerList.forEach(p => {
            a.push({
              id: p.id,
              name: p.trueName,
              number: p.number,
            })
          })
        }
      } else if (this.event.event === 3) {
        if (this.event.teamId && this.home.teamInfo?.id === this.event.teamId) {
          const playerList = JSON.parse(JSON.stringify(this.home.playerList))
          playerList.forEach(p => {
            if (this.type === 'p1' && p.id !== this.event.otherPlayerId) {
              a.push({
                id: p.id,
                name: p.trueName,
                number: p.number,
              })
            } else if (this.type === 'p2' && p.id !== this.event.playerId) {
              a.push({
                id: p.id,
                name: p.trueName,
                number: p.number,
              })
            }
          })
        } else if (this.event.teamId && this.away.teamInfo?.id === this.event.teamId) {
          const playerList = JSON.parse(JSON.stringify(this.away.playerList))
          playerList.forEach(p => {
            if (this.type === 'p1' && p.id !== this.event.otherPlayerId) {
              a.push({
                id: p.id,
                name: p.trueName,
                number: p.number,
              })
            } else if (this.type === 'p2' && p.id !== this.event.playerId) {
              a.push({
                id: p.id,
                name: p.trueName,
                number: p.number,
              })
            }
          })
        }
      }
      return a
    },
    eventTypeText() {
      const found = this.eventTypeOptions.find(i => i.value === this.event.event)
      return found ? found.text : ''
    }
  },
  watch: {
    isMe() {
      if (this.isMe) {
        this.adminGetBMBktGameData()
      }
    }
  },
  methods: {
    adminGetBMBktGameData() {
      adminGetBMBktGameData({ gameId:this.id }).then(res => {
        this.game = res.data.game
        // adminGetBMBktGameEventPlayerList
        const home = new Promise((resolve, reject) => {
          adminGetBMBktGameEventPlayerList({ matchId :this.matchId ,teamId: this.game.homeTeam.id }).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e)
          })
        })
        const away = new Promise((resolve, reject) => {
          adminGetBMBktGameEventPlayerList({ matchId: this.matchId, teamId: this.game.awayTeam.id }).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e)
          })
        })
        this.getTeamList(home, away)
      })
    },
    getTeamList(home, away) {
      Promise.all([home, away]).then(results => {
        const home = results[0]
        const away = results[1]
        this.home = home.data
        this.away = away.data
        if (this.eventId) {
          const event = JSON.parse(localStorage.getItem('bmb-event') || '{}')
          this.event = JSON.parse(localStorage.getItem('bmb-event') || '{}')
          if (event.type === 'goal' || event.type === 'penalty' || event.type === 'ownGoal') {
            this.event.event = 1
          } else if (event.type === 'yellow' || event.type === 'red') {
            this.event.event = 2
          } else if (event.type === 'changes') {
            this.event.event = 3
          }
          console.log(event);
          this.$nextTick(() => {
            console.log(2);
            if (event.type === 'goal' || event.type === 'penalty') {
              this.playerValue1 = event.trueName
              this.playerValue2 = event.otherName
            } else if (event.type === 'ownGoal') {
              this.playerValue3 = event.trueName
            } else if (event.type === 'yellow' || event.type === 'red') {
              this.playerValue4 = event.trueName
            } else if (event.type === 'changes') {
              this.playerValue5 = event.trueName
              this.playerValue6 = event.otherName
            }
            this.event.playerId = event.playerId
            this.event.otherPlayerId = event.otherPlayerId
          })
        }
      }).catch(e => { // 失败的时候则返回最先被reject失败状态的值
        console.log("error", e)
      })
    },
    onConfirm(value) {
      if (this.event.event === 1) {
        if (this.event.type === 'goal') {
          if (this.type === 'p1') {
            this.event.playerId = value.id
            this.playerValue1 = value.name
          } else if (this.type === 'p2') {
            this.event.otherPlayerId = value.id
            this.playerValue2 = value.name
          }
        } else if (this.event.type === 'ownGoal'  || this.event.type === 'penalty') {
          this.event.playerId = value.id
          this.playerValue3 = value.name
        }
      } if (this.event.event === 2) {
        this.event.playerId = value.id
        this.playerValue4 = value.name
      } else if (this.event.event === 3) {
        if (this.type === 'p1') {
          this.event.playerId = value.id
          this.playerValue5 = value.name
        } else if (this.type === 'p2') {
          this.event.otherPlayerId = value.id
          this.playerValue6 = value.name
        }
      } else if (this.event.event === 4) {
        this.event.playerId = value.id
        this.playerValue3 = value.name
      }
      this.showTeamList = false
    },
    showTeamListFun(type) {
      this.type = type
      this.showTeamList = true
    },
    update() {
      // 调用防抖版本的更新方法
      this.debouncedUpdate()
    },
    updateEvent() {
      this.$refs.event.validate().then(() => {
        const params = {
          gameId: this.game.id,
          ...this.event
        }
        if (this.event.event === 3) {
          params.type = 'changes'
        } else if (this.event.event === 4) {
          params.type = 'leaveBench'
        } else {
          params.type = this.event.type
        }
        if (this.eventId) {
          params.eventId = this.eventId
          adminUpdateBMGameEvent(params).then(res => {
            if (res) {
              Toast.success('更新成功')
              this.$router.go(-1)
            }
          })
        } else {
          adminAddBMGameEvent(params).then(res => {
            if (res) {
              Toast.success('添加成功')
              this.event = {
                teamId: '',
                time: '',
                event: '',
                type: '',
                playerId: '',
                otherPlayerId: ''
              }
              this.playerValue1 = ''
              this.playerValue2 = ''
              this.playerValue3 = ''
              this.playerValue4 = ''
              this.playerValue5 = ''
              this.playerValue6 = ''
            }
          })
        }
      })
    },
    clearPlayer() {
      console.log(1);
      const event = JSON.parse(JSON.stringify(this.event))
      event.playerId = ''
      event.otherPlayerId = ''
      this.playerValue1 = ''
      this.playerValue2 = ''
      this.playerValue3 = ''
      this.playerValue4 = ''
      this.playerValue5 = ''
      this.playerValue6 = ''
      this.event = event
    },
    goPages() {
      this.$router.push({ path: '/match-manage/football-time-line', query: { gameId : this.id}})
    },
    onEventTypeConfirm(option) {
      this.event.event = option.value
      this.showEventPicker = false
      this.clearPlayer() // 保持原有逻辑
    }
  }
};
</script>

<style lang="scss" scoped>
.events {
  .but{
    color: #1565FC;
    font-size: 14px;
    padding: 17px 0;
    background-color: #fff;
    text-align: center;
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 16px 12px 12px 8px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}
</style>
